import { Construction } from '@mui/icons-material';
import { Container, Stack, Typography } from '@mui/material';
import { StyleObj } from '../../@types';

type MaintenanceNoticeProps = {
  title?: string;
  messages: string[];
};

const styles: StyleObj = {
  container: {
    maxWidth: 'sm',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    overflowY: 'auto',
    py: 2,
  },
  content: {
    maxWidth: 800,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    m: 'auto',
    boxShadow: 2,
    p: 6,
    borderRadius: 4,
    backgroundColor: 'neutral.800',
    borderLeft: '8px solid',
    borderLeftColor: 'info.main',
  },
  icon: {
    fontSize: 100,
    color: 'info.main',
  },
  title: {
    typography: {
      xs: 'h4',
      md: 'h2',
    },
    textAlign: 'center',
  },
  message: {
    typography: {
      xs: 'body3',
      md: 'subtitle1',
    },
    textAlign: 'center',
  },
};

const MaintenanceNotice = ({ title, messages }: MaintenanceNoticeProps) => {
  const displayedMessages = messages.filter((message) => message.trim().length > 0);

  return (
    <Container sx={styles.container}>
      <Stack sx={styles.content}>
        <Construction sx={styles.icon} />
        {title && <Typography sx={styles.title}>{title}</Typography>}
        {displayedMessages.map((message) => (
          <Typography key={message} sx={styles.message}>
            {message}
          </Typography>
        ))}
      </Stack>
    </Container>
  );
};

export default MaintenanceNotice;
